import { FC } from 'react'

import { Loading } from '../../UI'
import { ControlPreventionItem } from '.'
import { useControlPrevention } from '../../../hooks'

import style from './ControlPrevention.module.css'

const ControlPrevention:FC = () => {
  const articles = useControlPrevention()

  return (
    <div className={style.containerArticles}>
      <div className={style.articles}>
        {articles.data ?
            articles.data.map((it: any, i: number) => <ControlPreventionItem article={it} index={i} key={it.id}/>)
            :
            <Loading overlay />
          }
      </div>
    </div>
  )
}

export { ControlPrevention }